var render = function render(_c,_vm){return _c('div',[(
      _vm.props.column === 'DateEnd' &&
      _vm.$options.isOutdated(_vm.props.row[_vm.props.column], _vm.$options.actualDate)
    )?_c('span',{staticClass:"outdated blink"},[_c('i',{staticClass:"el-icon-time"}),_vm._v(" "+_vm._s(_vm.$options.setFormatDate(_vm.props))+" ")]):(_vm.$options.formatDate(_vm.props.row[_vm.props.column]))?_c('span',[_c('i',{staticClass:"el-icon-time"}),_vm._v(" "+_vm._s(_vm.$options.setFormatDate(_vm.props))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }